export default __webpack_public_path__ + "static/media/cherrylovetv.60a0f93b.png";